// extracted by mini-css-extract-plugin
export var content = "_6s-3";
export var list = "_6s-4";
export var settingsContent = "_6s-7";
export var settingsPanel = "_6s-8";
export var state = "_6s-6";
export var triggerBadge = "_6s-2";
export var triggerButton = "_6s-1";
export var triggerShell = "_6s-0";
export var unreadDot = "_6s-5";